import { useMemo, useState } from 'react';

const TONE = {
  improving: 'ok',
  stable: 'info',
  needs_attention: 'warn',
  insufficient_data: 'muted'
};

export default function StatusBlock({ status }) {
  const [open, setOpen] = useState(false);
  if (!status) return null;
  const tone = TONE[status.code] || 'muted';

  return (
    <section className={'exec-status exec-status--' + tone} aria-labelledby="exec-status-title">
      <div className="exec-status-main">
        <p className="analytics-eyebrow">¿Cómo estamos?</p>
        <h2 id="exec-status-title" className="exec-status-label">
          {status.label}
        </h2>
        <button
          type="button"
          className="exec-status-toggle"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Ocultar detalle' : 'Ver por qué'}
        </button>
      </div>
      {open ? (
        <ul className="exec-status-reasons">
          {(status.reasons || []).map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}

export function useStatusTone(code) {
  return useMemo(() => TONE[code] || 'muted', [code]);
}
